import AcademyAdministrationIndex from "../../modules/academy/administration/Index.vue";
import AcademyAdministrationCategory from "../../modules/academy/administration/pages/Category.vue";
import AcademyAdministrationQuizModel from "../../modules/academy/administration/pages/QuizModel.vue";
import AcademyAdministrationEvaluations from "../../modules/academy/administration/pages/Evaluation.vue";
import AcademyAdministrationQuizForm from "../../modules/academy/administration/forms/Quiz.vue";

import AcademyLearnerIndex from "../../modules/academy/evaluation/Index.vue";
import AcademyLearnerEvaluation from "../../modules/academy/evaluation/pages/Evaluation.vue";
import AcademyLearnerResult from "../../modules/academy/evaluation/pages/Result.vue";

const routes = [
    {
        path: '/academy-admin', component: AcademyAdministrationIndex, children: [
            { path: 'category/:categoryId', component: AcademyAdministrationCategory },
            { path: 'quiz-model', component: AcademyAdministrationQuizModel },
            { path: 'quiz-form', component: AcademyAdministrationQuizForm },
            { path: 'quiz-form/:quizId', component: AcademyAdministrationQuizForm },
            { path: 'evaluations/', component: AcademyAdministrationEvaluations },
        ]
    },
    { path: '/academy-learner', component: AcademyLearnerIndex },
    { path: '/academy-evaluation/:quizId', component: AcademyLearnerEvaluation },
    { path: '/academy-result/:quizId', component: AcademyLearnerResult },
];

export default routes;